// components/Breadcrumbs.styled.ts
import MuiBreadcrumbs from "@mui/material/Breadcrumbs";
import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const StyledBreadcrumbs = styled(MuiBreadcrumbs)`
    color: ${colourScheme.white};
    font-size: 1rem;

    a {
        color: ${colourScheme.white};
        text-decoration: none;
        display: flex;
        align-items: center;
        &:hover {
            color: ${colourScheme.secondary};
        }
    }

    ${device.sm} {
        font-size: 1.25rem;
    }

    ${device.md} {
        font-size: 1.5rem;
    }
`;

export const CrumbLink = styled.a`
    cursor: pointer;
    /* Additional styling if needed */
`;
